import { useState } from "react";
import { Loader2 } from "lucide-react";
import axios from "axios";
import { API } from "@/lib/api";
import { LOGO_URL } from "@/lib/quoteContent";

export function ExpiredScreen({ slug }) {
  const [requested, setRequested] = useState(false);
  const [loading, setLoading] = useState(false);

  async function requestReactivation() {
    setLoading(true);
    try {
      await axios.post(`${API}/public/quotes/${slug}/request-reactivation`);
    } catch (e) {
      console.warn("Reactivation request failed; confirmation still shown", e);
    } finally {
      setRequested(true);
      setLoading(false);
    }
  }

  return (
    <div
      data-testid="quote-expired-screen"
      className="min-h-screen bg-[#21201F] text-white flex flex-col items-center justify-center px-6 text-center"
    >
      <img
        src={LOGO_URL}
        alt="Wedding Video Essex"
        className="h-24 md:h-28 w-auto object-contain brightness-0 invert opacity-95 mb-10"
      />
      <div className="text-xs tracking-overline uppercase text-[#A9927D] mb-4 font-medium">
        Quote Expired
      </div>
      <h1 className="font-display text-4xl md:text-6xl tracking-tight leading-tight mb-6 max-w-2xl">
        This quote has expired.
      </h1>
      <p className="text-white/70 max-w-lg mb-10 leading-relaxed">
        Thank you so much for considering us for your day. We held your date
        for 7 days, and this quote is no longer active. But not to worry, if
        you're still thinking about us, we'd love to hear from you. Just tap
        below and Alex will personally refresh your quote for you.
      </p>
      {requested ? (
        <div
          data-testid="reactivation-confirmed"
          className="bg-white/10 border border-white/20 px-8 py-5 max-w-md text-white/90"
        >
          Thanks! Alex has been notified and will personally refresh your
          quote shortly. Keep an eye on your inbox!
        </div>
      ) : (
        <button
          onClick={requestReactivation}
          disabled={loading}
          data-testid="request-reactivation-btn"
          className="inline-flex items-center gap-3 bg-[#CCBA56] hover:bg-[#B5A244] text-[#1F1E1D] px-10 py-4 text-xs tracking-overline uppercase font-medium transition-colors disabled:opacity-60"
        >
          {loading && <Loader2 className="w-4 h-4 animate-spin" strokeWidth={1.5} />}
          Request An Updated Quote
        </button>
      )}
    </div>
  );
}
